/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================
x
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
  // Card, CardBody, CardTitle,

  Container,
  Row, Col
} from "reactstrap";
import { Store, UpdateStore } from "StoreContext";
import { useState } from "react";
import api from "api";
// import CountUp from "react-countup";
import TotalBoxes from "./TotalBoxes";
import BrandSelector from "../BrandSelector/BrandSelector";
import { ReactComponent as Refresh } from '../../assets/header/refresh.svg';
import imageOne from '../../assets/header/imgOne.svg';
import imagetwo from '../../assets/header/totalScans.svg';
import imageFour from '../../assets/header/totalOrders.svg';
import imageThree from '../../assets/header/totalBrands.svg';
import rewardico from '../../assets/header/rewardIco.svg';


const Header = () => {
  const store = Store();
  const updateStore = UpdateStore();
  const [selectedBrandId, setSelectedBrandId] = useState("");

  const { user, stats } = store;

  const handleBrandChange = (brandId) => {
    setSelectedBrandId(brandId);
    const queryParam = brandId ? `?brandId=${brandId}` : "";
    api("get", `/users/stats${queryParam}`).then((res) => {
      updateStore({ stats: res?.stats });
    });
  };

  const renderScanGrowth = () => {
    // Compare last 30 days vs previous 30 days using monthly buckets
    const now = new Date();
    const curLabel = new Date(now.getFullYear(), now.getMonth(), 1)
      .toLocaleString("default", { month: "short" });
    const prevLabel = new Date(now.getFullYear(), now.getMonth() - 1, 1)
      .toLocaleString("default", { month: "short" });

    const cur = stats?.stats?.[curLabel] || 0;
    const prev = stats?.stats?.[prevLabel] || 0;

    if (prev === 0 && cur === 0) return null;
    if (prev === 0) {
      return (
        <span className="text-success mr-2">
          <i className="fa fa-arrow-up" /> New
        </span>
      );
    }

    const pct = ((cur - prev) / prev) * 100;
    const isUp = pct >= 0;

    return (
      <span className={`text-${isUp ? "success" : "danger"} mr-2`}>
        <i className={`fa fa-arrow-${isUp ? "up" : "down"}`} />{" "}
        {Math.abs(pct).toFixed(1)}% past 30 days
      </span>
    );
  };
  return (
    <>
      <div
        className="header pt-4 pt-md-7 "
        style={{
          background: "transparent",
        }}
      >
        {(window.location.pathname === "/brand/index" ||
          window.location.pathname === "/admin/index") && (
            <Container className="mb-4" fluid>
              <div className="d-flex align-items-center justify-content-between pb-5">
                <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                  <span style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    fontFamily: 'Outfit'
                  }} >{user?.role === "admin" ? "Admin Dashboard" : "Dashboard"}</span>
                  <Refresh cursor={'pointer'} onClick={() => { window.location.reload() }} />
                </div>
                {user?.role === "admin" && (
                  <BrandSelector
                    selectedBrandId={selectedBrandId}
                    onBrandChange={handleBrandChange}
                  />
                )}
              </div>
              <div className="header-body">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "16px",
                    width: "100%",
                    maxWidth: "1000px",
                  }}
                  className="vs-stat-grid"
                >
                  <TotalBoxes image={imageOne} heading={user?.role === 'admin' ? "Total Codes" : "Allocated Codes"} codeCount={user?.role === 'admin' ? stats?.codesCount : stats?.allCodesCount} />
                  <TotalBoxes image={imagetwo} renderGrowth={renderScanGrowth} heading={user?.role === 'admin' ? "Total Scans" : "Validated Scans"} codeCount={stats?.validatedCodesCount} />
                  <TotalBoxes image={imageThree} heading={user?.role === 'admin' ? "Total Brands" : "Orders Placed"} codeCount={user?.role === 'admin' ? stats?.brandCount : stats?.ordersCount ?? "3"} />
                  <TotalBoxes image={user?.role === 'admin' ? imageFour : rewardico} heading={user?.role === 'admin' ? "Total Orders" : "Total Batches"} codeCount={user?.role === 'admin' ? stats?.ordersCount : stats?.requestCount} />
                </div>
                {/* Card stats */}
                {/* <Row>
                  <Col lg="6" xl="3">
                    <Card className="card-stats mb-4 mb-xl-0">
                      <CardBody>
                        <Row>
                          {user?.role === "brand" ? (
                            <>
                              <div className="col">
                                <CardTitle
                                  tag="h5"
                                  className="text-uppercase text-muted mb-0"
                                >
                                  Amount of Codes
                                </CardTitle>
                                <span className="h2 font-weight-bold mb-0">
                                  <CountUp
                                    start={0}
                                    end={stats?.allCodesCount ?? 0}
                                    duration={2.5}
                                    separator=","
                                  />
                                </span>
                              </div>
                            </>
                          ) : (
                            <div className="col">
                              <CardTitle
                                tag="h5"
                                className="text-uppercase text-muted mb-0"
                              >
                                Codes
                              </CardTitle>
                              <span className="h2 font-weight-bold mb-0">
                                <CountUp
                                  start={0}
                                  end={stats?.codesCount ?? 0}
                                  duration={2.5}
                                  separator=","
                                />
                              </span>
                            </div>
                          )}
                          <Col className="col-auto">
                            <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                              <i className="fas fa-barcode" />
                            </div>
                          </Col>
                        </Row>
                        <p className="mt-3 mb-0 text-muted text-sm">
                          <span className="text-nowrap">All time amount</span>
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="6" xl="3">
                    <Card className="card-stats mb-4 mb-xl-0">
                      <CardBody>
                        <Row>
                          <div className="col">
                            <CardTitle
                              tag="h5"
                              className="text-uppercase text-muted mb-0"
                            >
                              Validated Codes
                            </CardTitle>
                            <span className="h2 font-weight-bold mb-0">
                              <CountUp
                                start={0}
                                end={stats?.validatedCodesCount ?? 0}
                                duration={2.5}
                                separator=","
                              />
                            </span>
                          </div>
                          <Col className="col-auto">
                            <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                              <i class="fas fa-check" />
                            </div>
                          </Col>
                        </Row>
                        <p className="mt-3 mb-0 text-muted text-sm">
                          {renderGrowth()}
                          <span className="text-nowrap">Since last month</span>
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="6" xl="3">
                    <Card className="card-stats mb-4 mb-xl-0">
                      <CardBody>
                        <Row>
                          {user?.role === "brand" ? (
                            <>
                              <div className="col">
                                <CardTitle
                                  tag="h5"
                                  className="text-uppercase text-muted mb-0"
                                >
                                  Invalidated Codes
                                </CardTitle>
                                <span className="h2 font-weight-bold mb-0">
                                  <CountUp
                                    start={0}
                                    end={stats?.invalidatedCodesCount ?? 0}
                                    duration={2.5}
                                    separator=","
                                  />
                                </span>
                              </div>
                              <Col className="col-auto">
                                <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                                  <i className="fa fa-times" />
                                </div>
                              </Col>
                            </>
                          ) : (
                            <>
                              <div className="col">
                                <CardTitle
                                  tag="h5"
                                  className="text-uppercase text-muted mb-0"
                                >
                                  Brands
                                </CardTitle>
                                <span className="h2 font-weight-bold mb-0">
                                  <CountUp
                                    start={0}
                                    end={stats?.brandCount ?? 0}
                                    duration={2.5}
                                    separator=","
                                  />
                                </span>
                              </div>
                              <Col className="col-auto">
                                <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                                  <i className="fas fa-users" />
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                        <p className="mt-3 mb-0 text-muted text-sm">
                          <span className="text-nowrap">All time amount</span>
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="6" xl="3">
                    <Card className="card-stats mb-4 mb-xl-0">
                      <CardBody>
                        <Row>
                          <div className="col">
                            <CardTitle
                              tag="h5"
                              className="text-uppercase text-muted mb-0"
                            >
                              Batch Requests
                            </CardTitle>
                            <span className="h2 font-weight-bold mb-0">
                              <CountUp
                                start={0}
                                end={stats?.requestCount ?? 0}
                                duration={2.5}
                                separator=","
                              />
                            </span>
                          </div>
                          <Col className="col-auto">
                            <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                              <i className="fas fa-plus" />
                            </div>
                          </Col>
                        </Row>
                        <p className="mt-3 mb-0 text-muted text-sm">
                          <span className="text-nowrap">All time amount</span>
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row> */}
              </div>
            </Container>
          )}
      </div >
    </>
  );
};

export default Header;
